import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="container">
        <h2 className="cta-title">Build Your <span>Team and Earn</span> with Aledger</h2>
        <p className="cta-description">Join thousands of node operators already building thriving communities in the Aledger ecosystem. Apply to become a team leader, stake your AFI tokens, and unlock multiple revenue streams while shaping the future of our network.</p>
        <div className="btn-group">
          <Link to="/node#node-application" className="btn">Apply for Node Status</Link>
          <a href="#products" className="btn btn-outline">Purchase Devices</a>
          <a href="#tokenomics" className="btn btn-outline">Explore Tokenomics</a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
